import "react-day-picker/lib/style.css";
import {
  RenderWarning,
  RenderActions,
  RenderInput,
  RenderText,
  RenderDateInput,
  RenderStateSelect,
  RenderCountySelect,
  RenderWageInput,
  RenderWageFrequency,
} from "../Shared/renderCells";

export default [
  {
    Header: " ", // needs to be a space if you want it blank
    width: 35,
    minWidth: 25,
    Cell: RenderWarning,
  },
  {
    Header: "Determined Wage",
    accessor: "determined_wage",
    width: 100,
    minWidth: 100,
    prependValue: "$",
    Cell: RenderText,
  },
  {
    Header: `1. City*`,
    accessor: "apdxaCity",
    Cell: RenderInput,
    charLimit: 35,
    validate: [
      "required",
      {
        maxLength: 35,
        message: "This field cannot be more than 35 characters long.",
      },
    ],
  },
  {
    Header: "2. State*",
    accessor: "apdxaState",
    width: 120,
    minWidth: 100,
    Cell: (props) =>
      RenderStateSelect({
        rowBlsAreaProperty: "apdxaMsa",
        appxCountyProperty: "apdxaCounty",
        ...props,
      }),
  },
  {
    Header: "3. County*",
    accessor: "apdxaCounty",
    Cell: (props) =>
      RenderCountySelect({
        rowBlsAreaProperty: "apdxaMsa",
        appxStateProperty: "apdxaState",
        ...props,
      }),
  },
  {
    Header: "4. MSA Name / OES Area Title*",
    accessor: "apdxaMsa",
    width: 200,
    minWidth: 200,
    Cell: RenderText,
  },
  {
    Header: "5. Additional Place of Employment Information",
    accessor: "apdxaAddlInfo",
    width: 200,
    minWidth: 200,
    charLimit: 120,
    Cell: RenderInput,
    validate: [
      {
        maxLength: 120,
        message: "This field cannot be more than 120 characters long.",
      },
    ],
  },
  {
    Header: "6. Crew ID",
    accessor: "apdxaCrewId",
    width: 50,
    minWidth: 50,
    Cell: RenderInput,
    charLimit: 2,
    validate: [
      {
        maxLength: 2,
        message: "This field cannot be more than 2 characters long.",
      },
    ],
  },
  {
    Header: "7. Total Workers",
    accessor: "apdxaTotalWorkers",
    width: 50,
    minWidth: 50,
    Cell: RenderInput,
    requiredFields: [
      {
        field: "tempneedWkrPos",
        message:
          "You must specify the number of workers allowed at each worksite in section B.",
      },
    ],
    validate: [
      {
        maxValue: "tempneedWkrPos",
        message:
          "Total workers must be less than or equal to the number of workers you specified in section B.",
        needsFieldValues: true,
        extraData: {
          operator: "<=",
          valueOf: "tempneedWkrPos",
        },
      },
    ],
    input: { type: "number", min: 0, max: 10000 },
  },
  {
    Header: "8. Begin Date",
    accessor: "apdxaBeginDate",
    width: 150,
    Cell: (props) =>
      RenderDateInput({
        beginDateProperty: "tempneedStart",
        endDateProperty: "tempneedEnd",
        rowBeginDateProperty: "apdxaBeginDate",
        rowEndDateProperty: "apdxaEndDate",
        originalDateSection: "B",
        ...props,
      }),
    overflow: "visible",
    validate: [],
  },
  {
    Header: "9. End Date",
    accessor: "apdxaEndDate",
    width: 150,
    Cell: (props) =>
      RenderDateInput({
        beginDateProperty: "tempneedStart",
        endDateProperty: "tempneedEnd",
        rowBeginDateProperty: "apdxaBeginDate",
        rowEndDateProperty: "apdxaEndDate",
        originalDateSection: "B",
        ...props,
      }),
    overflow: "visible",
    validate: [],
  },
  {
    Header: "10. Basic Wage Rate From",
    accessor: "apdxaWageFrom",
    width: 100,
    Cell: (props) =>
      RenderWageInput({
        newWagePerProperty: "apdxaWagePer",
        newWageFromProperty: "apdxaWageFrom",
        newWageToProperty: "apdxaWageTo",
        ...props,
      }),
  },
  {
    Header: "11. Basic Wage Rate To",
    accessor: "apdxaWageTo",
    width: 100,
    Cell: (props) =>
      RenderWageInput({
        newWagePerProperty: "apdxaWagePer",
        newWageFromProperty: "apdxaWageFrom",
        newWageToProperty: "apdxaWageTo",
        ...props,
      }),
  },
  {
    Header: "12. Per",
    accessor: "apdxaWagePer",
    width: 85,
    minWidth: 85,
    Cell: (props) =>
      RenderWageFrequency({
        wageFrequencyArray: [
          "Hourly",
          "Weekly",
          "Biweekly",
          "Monthly",
          "Annual",
        ],
        ...props,
      }),
  },
  {
    Header: "Actions",
    accessor: "actions",
    width: 100,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: RenderActions,
  },
];
